const Cancel = function () {
  this.editItem.modal.hide()
  this.editItem.resetEditItemModal()
}

export default Cancel
